<nz-space class="mobile-report-control">
  <app-project-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="code" [childOnly]="false">
  </app-project-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-project-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="code" [childOnly]="false"></app-project-select>
</nz-space>